(() => {
if(window.__deepSweepCanivetReady)return;
window.__deepSweepCanivetReady=true;

function dsLoadGallerySlide(gallery,index,priority='auto'){
  const thumb=gallery?.querySelectorAll('[data-ds-thumb]')?.[index];
  const image=gallery?.querySelector(`[data-ds-gallery-slide="${index}"] [data-ds-gallery-image]`);
  if(!thumb||!image)return;
  image.loading='eager';
  image.fetchPriority=priority;
  if(image.dataset.sizes)image.sizes=image.dataset.sizes;
  if(image.dataset.srcset)image.srcset=image.dataset.srcset;
  if(image.dataset.src)image.src=image.dataset.src;
  delete image.dataset.sizes;
  delete image.dataset.srcset;
  delete image.dataset.src;
}
function dsKeepGalleryThumbVisible(thumb){
  const track=thumb?.parentElement;
  if(!track||track.scrollWidth<=track.clientWidth)return;
  const left=thumb.offsetLeft-(track.clientWidth-thumb.offsetWidth)/2;
  track.scrollTo({
    left:Math.max(0,left),
    behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'
  });
}
function dsMarkGalleryIndex(gallery,index){
  const thumbs=Array.from(gallery?.querySelectorAll('[data-ds-thumb]')||[]);
  const slides=Array.from(gallery?.querySelectorAll('[data-ds-gallery-slide]')||[]);
  if(!gallery||!thumbs.length||!slides.length)return;
  const safeIndex=Math.max(0,Math.min(thumbs.length-1,index));
  thumbs.forEach(function(item,itemIndex){item.setAttribute('aria-current',String(itemIndex===safeIndex));});
  slides.forEach(function(slide,slideIndex){
    const active=slideIndex===safeIndex;
    slide.classList.toggle('is-active',active);
    slide.setAttribute('aria-hidden',String(!active));
    const image=slide.querySelector('[data-ds-gallery-image]');
    if(active)image?.setAttribute('data-ds-main-image','');
    else image?.removeAttribute('data-ds-main-image');
  });
  const frame=gallery.querySelector('.ds-gallery-main');
  frame?.setAttribute('aria-label',`Product image ${safeIndex+1} of ${thumbs.length}. Swipe left or right to change image.`);
  dsKeepGalleryThumbVisible(thumbs[safeIndex]);
  [safeIndex-1,safeIndex,safeIndex+1].forEach(function(preloadIndex){
    if(thumbs[preloadIndex])dsLoadGallerySlide(gallery,preloadIndex,preloadIndex===safeIndex?'high':'auto');
  });
  dsSyncStickyAtc();
}
function dsSelectGalleryThumb(thumb,behavior){
  const gallery=thumb?.closest('[data-ds-gallery]');
  const frame=gallery?.querySelector('.ds-gallery-main');
  const thumbs=Array.from(gallery?.querySelectorAll('[data-ds-thumb]')||[]);
  const index=thumbs.indexOf(thumb);
  const slide=gallery?.querySelector(`[data-ds-gallery-slide="${index}"]`);
  if(!gallery||!frame||index<0||!slide)return;
  dsMarkGalleryIndex(gallery,index);
  frame.scrollTo({left:slide.offsetLeft,behavior:behavior||'smooth'});
}
function dsStepGallery(gallery,direction){
  const thumbs=Array.from(gallery?.querySelectorAll('[data-ds-thumb]')||[]);
  if(thumbs.length<2)return;
  let currentIndex=thumbs.findIndex(function(thumb){return thumb.getAttribute('aria-current')==='true';});
  if(currentIndex<0)currentIndex=0;
  const nextIndex=Math.max(0,Math.min(thumbs.length-1,currentIndex+direction));
  if(nextIndex!==currentIndex)dsSelectGalleryThumb(thumbs[nextIndex]);
}
function dsInitProductGalleries(){
  document.querySelectorAll('[data-ds-gallery]').forEach(function(gallery){
    if(gallery.dataset.dsGalleryReady==='true')return;
    gallery.dataset.dsGalleryReady='true';
    const thumbs=Array.from(gallery.querySelectorAll('[data-ds-thumb]'));
    const frame=gallery.querySelector('.ds-gallery-main');
    if(frame&&thumbs.length>1){
      const originalImage=frame.querySelector('[data-ds-main-image]');
      const track=document.createElement('div');
      const initialIndex=Math.max(0,thumbs.findIndex(function(thumb){return thumb.getAttribute('aria-current')==='true';}));
      track.className='ds-gallery-track';
      track.setAttribute('data-ds-gallery-track','');
      thumbs.forEach(function(thumb,index){
        const slide=document.createElement('div');
        const image=index===initialIndex&&originalImage?originalImage:document.createElement('img');
        slide.className='ds-gallery-slide';
        slide.dataset.dsGallerySlide=String(index);
        slide.setAttribute('aria-hidden',String(index!==initialIndex));
        image.setAttribute('data-ds-gallery-image','');
        image.draggable=false;
        image.decoding='async';
        image.loading=index===initialIndex?'eager':'lazy';
        image.fetchPriority=index===initialIndex?'high':'low';
        if(index!==initialIndex||!originalImage){
          if(thumb.dataset.sizes)image.dataset.sizes=thumb.dataset.sizes;
          if(thumb.dataset.srcset)image.dataset.srcset=thumb.dataset.srcset;
          if(thumb.dataset.src)image.dataset.src=thumb.dataset.src;
          image.alt=thumb.dataset.alt||thumb.querySelector('img')?.alt||'';
        }
        slide.appendChild(image);
        track.appendChild(slide);
      });
      frame.replaceChildren(track);
      let pointerId=null;
      let startX=0;
      let startY=0;
      let startScrollLeft=0;
      let startIndex=initialIndex;
      let dragged=false;
      let scrollFrame=0;
      const resetSwipe=function(){pointerId=null;dragged=false;frame.classList.remove('is-swiping');};
      frame.tabIndex=0;
      frame.setAttribute('role','group');
      frame.setAttribute('aria-label',`Product image ${initialIndex+1} of ${thumbs.length}. Swipe left or right to change image.`);
      frame.addEventListener('dragstart',function(event){event.preventDefault();});
      frame.addEventListener('pointerdown',function(event){
        if(event.pointerType==='mouse'&&event.button!==0)return;
        pointerId=event.pointerId;
        startX=event.clientX;
        startY=event.clientY;
        startScrollLeft=frame.scrollLeft;
        startIndex=Math.round(frame.scrollLeft/frame.clientWidth);
        dragged=false;
        frame.classList.add('is-swiping');
        try{frame.setPointerCapture?.(event.pointerId);}catch(error){}
      });
      frame.addEventListener('pointermove',function(event){
        if(pointerId!==event.pointerId)return;
        const deltaX=event.clientX-startX;
        const deltaY=event.clientY-startY;
        if(!dragged&&Math.abs(deltaX)<5)return;
        if(!dragged&&Math.abs(deltaX)<=Math.abs(deltaY))return;
        dragged=true;
        event.preventDefault();
        frame.scrollLeft=startScrollLeft-deltaX;
      });
      frame.addEventListener('pointerup',function(event){
        if(pointerId!==event.pointerId)return;
        const deltaX=event.clientX-startX;
        const deltaY=event.clientY-startY;
        const threshold=Math.max(32,Math.min(58,frame.clientWidth*.08));
        let targetIndex=Math.round(frame.scrollLeft/frame.clientWidth);
        if(Math.abs(deltaX)>=threshold&&Math.abs(deltaX)>Math.abs(deltaY)*1.05){
          targetIndex=startIndex+(deltaX<0?1:-1);
        }
        targetIndex=Math.max(0,Math.min(thumbs.length-1,targetIndex));
        resetSwipe();
        dsMarkGalleryIndex(gallery,targetIndex);
        frame.scrollTo({left:targetIndex*frame.clientWidth,behavior:'smooth'});
      });
      frame.addEventListener('pointercancel',function(){
        const targetIndex=Math.max(0,Math.min(thumbs.length-1,Math.round(frame.scrollLeft/frame.clientWidth)));
        resetSwipe();
        dsMarkGalleryIndex(gallery,targetIndex);
        frame.scrollTo({left:targetIndex*frame.clientWidth,behavior:'smooth'});
      });
      frame.addEventListener('scroll',function(){
        if(scrollFrame)return;
        scrollFrame=window.requestAnimationFrame(function(){
          scrollFrame=0;
          dsMarkGalleryIndex(gallery,Math.round(frame.scrollLeft/frame.clientWidth));
        });
      },{passive:true});
      frame.addEventListener('keydown',function(event){
        if(event.key!=='ArrowLeft'&&event.key!=='ArrowRight')return;
        event.preventDefault();
        dsStepGallery(gallery,event.key==='ArrowRight'?1:-1);
      });
      frame.scrollLeft=initialIndex*frame.clientWidth;
      dsMarkGalleryIndex(gallery,initialIndex);
    }
    thumbs.forEach(function(thumb){
      ['pointerenter','focusin','touchstart'].forEach(function(eventName){
        thumb.addEventListener(eventName,function(){
          const index=thumbs.indexOf(thumb);
          dsLoadGallerySlide(gallery,index,'auto');
        },{passive:true,once:true});
      });
    });
  });
}
document.addEventListener('click',function(event){
  const thumb=event.target.closest('[data-ds-thumb]');
  if(thumb){dsSelectGalleryThumb(thumb);return;}
});
dsInitProductGalleries();
function dsInitMobileMenu(){
  document.querySelectorAll('.ds-header').forEach(function(header){
    if(header.dataset.dsMenuReady==='true')return;
    const nav=header?.querySelector('.ds-nav');
    if(!nav)return;
    const menuButtons=header.querySelectorAll('[data-ds-menu]');
    const openButton=header.querySelector('.ds-menu-toggle');
    let restoreFocus=openButton;
    header.dataset.dsMenuReady='true';

    function setMenuState(open){
      nav.classList.toggle('is-open',open);
      document.documentElement.classList.toggle('ds-menu-open',open);
      document.body.classList.toggle('ds-menu-open',open);
      menuButtons.forEach(function(button){
        button.setAttribute('aria-expanded',String(open));
      });
      openButton?.setAttribute('aria-label',open?'Close menu':'Open menu');
      if(open){
        restoreFocus=document.activeElement instanceof HTMLElement?document.activeElement:openButton;
        window.requestAnimationFrame(function(){header.querySelector('.ds-nav__close')?.focus();});
      }else if(restoreFocus instanceof HTMLElement){
        restoreFocus.focus();
      }
    }

    menuButtons.forEach(function(menuButton){
      menuButton.addEventListener('click',function(){
        setMenuState(!nav.classList.contains('is-open'));
      });
    });
    nav.addEventListener('click',function(event){
      if(event.target.closest('a[href]'))setMenuState(false);
    });
    header.addEventListener('keydown',function(event){
      if(event.key==='Escape'&&nav.classList.contains('is-open')){
        event.preventDefault();
        setMenuState(false);
        return;
      }
      if(event.key==='Tab'&&nav.classList.contains('is-open')){
        const focusable=Array.from(nav.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled])')).filter(function(element){
          return element.offsetParent!==null;
        });
        const first=focusable[0];
        const last=focusable[focusable.length-1];
        if(!first||!last)return;
        if(event.shiftKey&&document.activeElement===first){
          event.preventDefault();
          last.focus();
        }else if(!event.shiftKey&&document.activeElement===last){
          event.preventDefault();
          first.focus();
        }
      }
    });
  });
}
dsInitMobileMenu();
document.addEventListener('change',function(event){
  if(event.target.matches('[data-ds-sort]'))event.target.form?.submit();
});
function dsUpdateVariant(options){
  const syncGallery=options?.syncGallery!==false;
  const root=document.querySelector('[data-ds-product]');if(!root)return;
  const data=JSON.parse(root.querySelector('[data-ds-variants]')?.textContent||'[]');
  const colorInput=root.querySelector('input[name="ds-color"]:checked');
  const color=colorInput?.value;
  const colorOptionIndex=Math.max(0,Number(colorInput?.dataset.dsOptionPosition||1)-1);
  const kit=root.querySelector('input[name="ds-kit"]:checked')?.value;
  const exactVariant=data.find(v=>v.options&&v.options[colorOptionIndex]===color&&v.options.some(option=>option===kit));
  const variant=exactVariant;
  const select=root.querySelector('select[name="id"]');
  if(variant&&select){select.value=String(variant.id);select.dispatchEvent(new Event('change',{bubbles:true}));}
  const activeCard=root.querySelector('input[name="ds-kit"]:checked')?.closest('.ds-kit');
  const price=activeCard?.querySelector('[data-ds-current-price]');
  const comparePrice=price?.parentElement?.querySelector('s');
  const addButton=root.querySelector('button[name="add"]');
  if(price&&variant)price.textContent=(variant.price/100).toLocaleString(undefined,{style:'currency',currency:'USD'});
  if(comparePrice&&variant){
    comparePrice.textContent=variant.compare_at_price?(variant.compare_at_price/100).toLocaleString(undefined,{style:'currency',currency:'USD'}):'';
    comparePrice.hidden=!variant.compare_at_price;
  }
  if(addButton){
    const purchasable=Boolean(variant&&variant.available);
    addButton.disabled=!purchasable;
    addButton.setAttribute('aria-disabled',String(!purchasable));
    addButton.textContent=purchasable?'Add to cart':(variant?'Sold out':'Option unavailable');
  }
  const featuredImage=variant?.featured_image;
  if(featuredImage&&syncGallery){
    const gallery=root.querySelector('[data-ds-gallery]');
    const thumb=gallery?.querySelector(`[data-ds-thumb][data-media-id="${featuredImage.id}"]`);
    const main=gallery?.querySelector('[data-ds-main-image]');
    if(thumb){thumb.click();}
    else if(main&&featuredImage.src){main.src=featuredImage.src;if(featuredImage.alt)main.alt=featuredImage.alt;}
  }
  dsSyncStickyAtc();
}
function dsSyncStickyAtc(){
  const root=document.querySelector('[data-ds-product]');
  const bar=document.querySelector('[data-ds-sticky-atc]');
  if(!root||!bar)return;
  const activeCard=root.querySelector('input[name="ds-kit"]:checked')?.closest('.ds-kit');
  const mainButton=root.querySelector('#DeepSweepProductForm button[name="add"]');
  const currentPrice=activeCard?.querySelector('[data-ds-current-price]');
  const comparePrice=currentPrice?.parentElement?.querySelector('s');
  const activeThumb=root.querySelector('[data-ds-thumb][aria-current="true"]');
  const mainImage=root.querySelector('[data-ds-main-image]');
  const stickyImage=bar.querySelector('[data-ds-sticky-image]');
  const title=bar.querySelector('[data-ds-sticky-title]');
  const variant=bar.querySelector('[data-ds-sticky-variant]');
  const stickyPrice=bar.querySelector('[data-ds-sticky-price]');
  const stickyCompare=bar.querySelector('[data-ds-sticky-compare]');
  const stickyButton=bar.querySelector('[data-ds-sticky-submit]');
  if(title)title.textContent=root.querySelector('.ds-product-title')?.textContent.trim()||'DeepSweep Kit';
  if(variant)variant.textContent=activeCard?.querySelector('.ds-kit-title')?.textContent.trim()||'';
  if(stickyPrice)stickyPrice.textContent=currentPrice?.textContent.trim()||'';
  if(stickyCompare){
    stickyCompare.textContent=comparePrice?.textContent.trim()||'';
    stickyCompare.hidden=!comparePrice||comparePrice.hidden||!stickyCompare.textContent;
  }
  if(stickyImage){
    const thumbImage=activeThumb?.querySelector('img');
    const source=thumbImage?.currentSrc||thumbImage?.src||mainImage?.currentSrc||mainImage?.src;
    if(source&&stickyImage.src!==source)stickyImage.src=source;
    stickyImage.alt=mainImage?.alt||title?.textContent||'DeepSweep dental cleaner';
  }
  if(stickyButton&&mainButton){
    stickyButton.disabled=mainButton.disabled;
    stickyButton.setAttribute('aria-disabled',String(mainButton.disabled));
    stickyButton.textContent=mainButton.textContent.trim();
  }
}
function dsInitStickyAtc(){
  const root=document.querySelector('[data-ds-product]');
  const bar=root?.querySelector('[data-ds-sticky-atc]')||document.querySelector('[data-ds-sticky-atc]');
  const form=root?.querySelector('#DeepSweepProductForm');
  const mainButton=form?.querySelector('button[name="add"]');
  const stickyButton=bar?.querySelector('[data-ds-sticky-submit]');
  if(!root||!bar||!form||!mainButton||!stickyButton||bar.dataset.dsStickyReady==='true')return;
  bar.dataset.dsStickyReady='true';
  document.body.appendChild(bar);
  let frame=0;

  function cartIsOpen(){
    return Boolean(document.querySelector('#cart-drawer dialog[open]'));
  }
  function mainButtonIsVisible(){
    const rect=mainButton.getBoundingClientRect();
    return rect.bottom>0&&rect.top<window.innerHeight;
  }
  function footerIsNear(){
    const footer=document.querySelector('.ds-footer, footer');
    if(!footer)return false;
    const rect=footer.getBoundingClientRect();
    return rect.top<window.innerHeight+bar.offsetHeight&&rect.bottom>0;
  }
  function update(){
    frame=0;
    const active=!mainButtonIsVisible()&&!footerIsNear()&&!cartIsOpen()&&!document.body.classList.contains('ds-menu-open');
    bar.classList.toggle('is-active',active);
    bar.setAttribute('aria-hidden',String(!active));
    document.body.classList.toggle('ds-sticky-atc-active',active);
    document.body.classList.toggle('ds-cart-drawer-open',cartIsOpen());
    document.documentElement.style.setProperty('--ds-sticky-atc-height',`${bar.offsetHeight}px`);
  }
  function scheduleUpdate(){
    if(frame)return;
    frame=window.requestAnimationFrame(update);
  }
  stickyButton.addEventListener('click',function(){
    if(mainButton.disabled){
      form.scrollIntoView({behavior:'smooth',block:'center'});
      return;
    }
    if(typeof form.requestSubmit==='function')form.requestSubmit(mainButton);
    else mainButton.click();
  });
  const observer=new MutationObserver(function(){dsSyncStickyAtc();scheduleUpdate();});
  observer.observe(mainButton,{attributes:true,childList:true,subtree:true,characterData:true});
  const drawer=document.querySelector('#cart-drawer');
  if(drawer)observer.observe(drawer,{attributes:true,childList:true,subtree:true,attributeFilter:['open','class']});
  const mainImage=root.querySelector('[data-ds-main-image]');
  if(mainImage)observer.observe(mainImage,{attributes:true,attributeFilter:['src','srcset','alt']});
  window.addEventListener('scroll',scheduleUpdate,{passive:true});
  window.addEventListener('resize',scheduleUpdate,{passive:true});
  dsSyncStickyAtc();
  update();
}
document.addEventListener('change',function(event){
  if(event.target.matches('input[name="ds-color"],input[name="ds-kit"]')){
    dsUpdateVariant();
    const label=document.querySelector('[data-ds-color-label]');
    if(label&&event.target.name==='ds-color')label.textContent=event.target.value;
  }
});
document.addEventListener('input',function(event){
  if(event.target.matches('[data-ds-range]')){
    const after=event.target.closest('[data-ds-before-after]')?.querySelector('[data-ds-after]');
    const root=event.target.closest('[data-ds-before-after]');
    if(after)after.style.width=`${100-Number(event.target.value)}%`;
    if(root)root.style.setProperty('--ds-split',`${event.target.value}%`);
  }
});
document.addEventListener('click',function(event){
  if(event.target.closest('[data-ds-scroll-reviews]'))document.querySelector('#DeepSweepReviews')?.scrollIntoView({behavior:'smooth'});
});
function dsLoadReferenceVideo(video){
  if(!video||video.dataset.dsVideoLoaded==='true')return;
  video.querySelectorAll('source[data-src]').forEach(function(source){source.src=source.dataset.src;});
  video.dataset.dsVideoLoaded='true';
  video.load();
}
function dsPlayReferenceVideo(video){
  if(!video||video.dataset.dsUserPaused==='true')return;
  dsLoadReferenceVideo(video);
  video.muted=true;
  video.defaultMuted=true;
  video.volume=0;
  video.playsInline=true;
  video.loop=true;
  const attempt=video.play();
  if(attempt&&typeof attempt.catch==='function')attempt.catch(function(){});
}
function dsInitReferenceVideos(){
  const videos=Array.from(document.querySelectorAll('[data-ds-autoplay-video]')).filter(function(video){
    if(video.dataset.dsVideoReady==='true')return false;
    video.dataset.dsVideoReady='true';
    dsSyncVideoToggle(video);
    return true;
  });
  if(!videos.length)return;
  if(!('IntersectionObserver' in window)){
    videos.forEach(dsPlayReferenceVideo);
    return;
  }
  const observer=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      const video=entry.target;
      if(entry.isIntersecting)dsPlayReferenceVideo(video);
      else if(!video.paused)video.pause();
    });
  },{rootMargin:'300px 0px',threshold:.01});
  videos.forEach(function(video){observer.observe(video);});
}
function dsSyncVideoToggle(video){
  const shell=video.closest('[data-ds-video-shell]');
  const button=shell?.querySelector('[data-ds-video-toggle]');
  if(!shell||!button)return;
  const paused=video.paused&&video.dataset.dsUserPaused==='true';
  shell.classList.toggle('is-paused',paused);
  button.hidden=!paused;
  button.tabIndex=paused?0:-1;
  button.setAttribute('aria-label',`Play ${video.getAttribute('aria-label')||'demonstration video'}`);
}
function dsToggleReferenceVideo(video){
  if(!video)return;
  if(video.paused){
    delete video.dataset.dsUserPaused;
    dsPlayReferenceVideo(video);
  }else{
    video.dataset.dsUserPaused='true';
    video.pause();
  }
}
document.addEventListener('click',function(event){
  const shell=event.target.closest('[data-ds-video-shell]');
  if(!shell)return;
  event.preventDefault();
  dsToggleReferenceVideo(shell.querySelector('[data-ds-autoplay-video]'));
},true);
document.addEventListener('play',function(event){
  if(event.target.matches?.('[data-ds-autoplay-video]'))dsSyncVideoToggle(event.target);
},true);
document.addEventListener('pause',function(event){
  if(event.target.matches?.('[data-ds-autoplay-video]'))dsSyncVideoToggle(event.target);
},true);
document.addEventListener('loadeddata',function(event){
  if(event.target.matches?.('[data-ds-autoplay-video]'))dsSyncVideoToggle(event.target);
},true);
document.addEventListener('volumechange',function(event){
  if(event.target.matches?.('[data-ds-autoplay-video]')&&!event.target.muted){event.target.muted=true;event.target.volume=0;}
},true);
document.addEventListener('DOMContentLoaded',function(){
  dsUpdateVariant({syncGallery:false});
  dsInitStickyAtc();
  dsInitReferenceVideos();
  const timer=document.querySelector('[data-ds-bonus-timer]');
  if(!timer)return;
  let seconds=8*3600+26*60+5;
  window.setInterval(function(){seconds=Math.max(0,seconds-1);const h=String(Math.floor(seconds/3600)).padStart(2,'0');const m=String(Math.floor(seconds%3600/60)).padStart(2,'0');const s=String(seconds%60).padStart(2,'0');timer.textContent=`${h}:${m}:${s}`;},1000);
});

function dsInitGuarantees(){
  document.querySelectorAll('[data-ds-guarantee]').forEach(function(details){
    if(details.dataset.dsGuaranteeReady==='true')return;
    const summary=details.querySelector(':scope > summary');
    if(!summary)return;
    details.dataset.dsGuaranteeReady='true';
    let animation=null;
    let closing=false;

    function finish(open){
      animation=null;
      closing=false;
      details.style.height='';
      details.style.overflow='';
      if(!open)details.open=false;
    }

    function animate(open){
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        details.open=open;
        return;
      }
      if(animation)animation.cancel();
      const startHeight=details.getBoundingClientRect().height;
      if(open)details.open=true;
      const endHeight=open?details.scrollHeight:summary.getBoundingClientRect().height+4;
      details.style.height=`${startHeight}px`;
      details.style.overflow='hidden';
      closing=!open;
      animation=details.animate(
        {height:[`${startHeight}px`,`${endHeight}px`]},
        {duration:320,easing:'cubic-bezier(0.2, 0.8, 0.2, 1)'}
      );
      animation.onfinish=function(){finish(open);};
      animation.oncancel=function(){animation=null;};
    }

    summary.addEventListener('click',function(event){
      event.preventDefault();
      animate(!details.open||closing);
    });
  });
}

dsInitGuarantees();
dsInitStickyAtc();
document.addEventListener('DOMContentLoaded',dsInitGuarantees);

})();
